var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 5"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M0 0l5 5 5-5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }